import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import PropTypes from "prop-types";

function Confirmation({ warning, onCancel, onContinue }) {
  const [showWarning, setWarning] = useState(false);
  useEffect(() => {
    if (warning && warning != "") {
      setWarning(true);
    }
  }, [warning]);
  return (
    <>
      <div
        className="col-11 col-sm-4"
        style={{
          display: showWarning ? "inline-block" : "none",
          margin: "0 auto",
          position: "fixed",
          transition: "all 0.5s ease-in-out 0s",
          zIndex: 9999,
          top: 20,
          left: 0,
          right: 0,
        }}
      >
        <div
          className="animated fadeInDown alert alert-primary alert-dismissible fade show"
          role="alert"
        >
          <span data-notify="message text-white">
            <b>{warning}</b>
          </span>
          <br />
          <br />
          <button
            type="button"
            className="btn-fill pull-right btn btn-info btn-sm me-2"
            onClick={() => {
              setWarning(false);
              onContinue();
            }}
          >
            Continue
          </button>
          <button
            type="button"
            className="btn-fill pull-right btn btn-warning btn-sm  "
            onClick={() => {
              setWarning(false);
              onCancel();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
}

Confirmation.propTypes = {
  warning: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default Confirmation;
